import { InfoLeagueProps } from '../leagues.props';
import { Ruby } from './Ruby';

export const RubyLeague: InfoLeagueProps = {
  id: `${process.env.REACT_APP_ID_LEAGUE_RUBY}`,
  name: 'Rubí',
  description: "Los guerreros más valientes accederán a esta arena.",
  icon: '🔴',
  active: false,
  color: '#FFFFFF',
  bgColor: '#C1121F',
  borderColor: '#C1121F',
  path: '/ruby',
  page: Ruby,
};
